import { createAction, props } from "@ngrx/store";
import { IStateClubGame } from "./clubLobby.state";

export const updateGameTable = createAction(
    '[ClubLobby] Update Game Table',
    props<{
        game: IStateClubGame;
    }>()
);

export const removeGameTable = createAction(
    '[ClubLobby] Remove Game Table',
    props<{
        tableId: string;
    }>()
    );
    
export const updateUnionGameTable = createAction(
    '[ClubLobby] Update Union Game Table',
    props<{
        clubId: string;
        tableId: string;
        game: IStateClubGame;
    }>()
);

export const removeUnionGameTable = createAction(
    '[ClubLobby] Remove Union Game Table',
    props<{
        clubId: string;
        tableId: string;
    }>()
);
    
export const removeUnionClubGames = createAction(
    '[ClubLobby] Remove Union Game Table',
    props<{
        clubId: string;
    }>()
);

export const setSelectedFilter = createAction(
    '[ClubLobby] Set Selected Filter',
    props<{
        selectedFilter: string;
    }>()
);

export const setIsUnionSelected = createAction(
    '[ClubLobby] Set Is Union Selected',
    props<{
        isUnionSelected: boolean;
    }>()
);

export const resetGamesState = createAction(
    '[ClubLobby] Reset Games State',
);
